import { render } from "./EventCard.vue?vue&type=template&id=1a2425e0&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1a2425e0"

export default script